import React, {useContext, useState} from "react";
import {Button, Col, FormGroup,} from "reactstrap";
import Select from "react-select";
import {AppContext} from "../../../App";
import _ from "lodash";
import {commitMutation, useRelayEnvironment} from "react-relay";
import graphql from "babel-plugin-relay/macro";
import {toast, ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {GetManageGroupsPermission} from "../list/listGroup";
import {POWER_EDITORS} from "../../../utils/config";
import {getCmpV2IdsFromServiceSet} from "../../../utils/cmpV2Utils";


const CreateGroupV2 = ({history}) => {

  const {userGroupsUserServiceInfo: userTenants, userAllPermissions, userProfile} = useContext(AppContext)
  const {auth0Id,emailAddress} = userProfile
  const alphabetizeLabels = (opt1, opt2) => opt1.label.localeCompare(opt2.label)
  let TenantOptions = _.isEmpty(userTenants) ? [] :
    userTenants.map(item => {
      return {label : item?.groupName, value : item?.groupUuid}

    })
      .sort(alphabetizeLabels)

  TenantOptions = TenantOptions.filter(item => GetManageGroupsPermission(item?.value,userAllPermissions))

  if(POWER_EDITORS.includes(emailAddress)) {
    const cmpV2Tenants = getCmpV2IdsFromServiceSet(userTenants)
    TenantOptions = TenantOptions.filter(item => cmpV2Tenants.includes(item?.value))
  }


  const [selectedTenant, setSelectedTenant] = useState("");
  const [name, setName] = useState();
  const environment = useRelayEnvironment()

  const handleSubmit = (e) => {
    e.preventDefault()
    commitMutation(environment, {   // <EditUserGroupMutation>
      mutation: graphql`
        mutation createGroupV2Mutation($selectedTenant: String!, $name: String!, $userId: String) {
          addUserGroupV2(tenantUuid: $selectedTenant, name: $name, userId: $userId) {
            name
            uuid
          }
        }
      `,   // updatedGroup is used to update services list in local cache automatically
      variables: { selectedTenant : selectedTenant.value, name, userId : auth0Id},
      onCompleted: response => {
        if (response?.addUserGroupV2?.name === name) {
          toast("Successfully Created")
          setTimeout(() => {
            history.push("/app/v2/groups")
          }, 2000)
        }
      },
      onError: error => {
        console.log({error})
        toast(`Error: ${error}`)
      }
    })
  }
  return (
    <div style={{margin: "5vh"}}>
      <h3>Create Group</h3>
      <form onSubmit={handleSubmit}>
        <FormGroup row>
          <Col sm={8}>
            <Select
              className="form-select"
              options={TenantOptions}
              value={selectedTenant}
              onChange={e => setSelectedTenant(e)}
              placeholder={"select Tenant"}/>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col sm={8}>
            <input
              className="form-control"
              type="text"
              required
              placeholder="Group Name"
              value={name || ""}
              onChange={e => setName(e.target.value)}
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col sm={8}>
            <fieldset style={{border: "1px solid"}}>
              <legend style={{margin: "20px", width: "155px", inlineSize: "auto"}}> &nbsp;Features &
                Services&nbsp;</legend>
              <FormGroup style={{marginLeft: "20px"}}>
                <Col sm={10}>
                  <Select
                    className="form-select"
                    id="TenantSelect"
                    placeholder="All Experiences"/>
                </Col>
              </FormGroup>
              <FormGroup style={{marginLeft: "20px"}}>
                <Col sm={10}>
                  <Select
                    className="form-select"
                    id="TenantSelect"
                    placeholder="Select Domain(s)"/>
                </Col>
              </FormGroup>
              <FormGroup style={{marginLeft: "20px"}}>
                <Col sm={10}>
                  <Select
                    className="form-select"
                    id="TenantSelect"
                    placeholder="Features"/>
                </Col>
              </FormGroup>
            </fieldset>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col sm={8} className="d-flex">
            <Col sm={{
              offset: 0,
              size: "auto"
            }}>
              <Button color="primary" onClick={() => history.push("/app/v2/groups")}> Back </Button>
            </Col>
            <Col sm={{
              offset: 8,
              size: "auto"
            }} className="d-flex justify-content-end">
              <Button color="danger" style={{marginRight: "10px"}}> Cancel </Button>
              <Button color="success" type="submit"> Create </Button>
            </Col>
          </Col>
        </FormGroup>
        <ToastContainer />
      </form>
    </div>
  )

}

export default (props) => {
  return (
    <React.Suspense fallback={"Loading Groups..."}>
      <CreateGroupV2 {...props} />
    </React.Suspense>
  )
}
